export default "__VITE_ASSET__DC468gL$__"